import { Container, Grid, Typography, Button, TextField } from '@material-ui/core';
import React, { Component } from 'react';
import axios from 'axios';
import labels from '../../constant/labels';
import { withRouter } from 'react-router-dom';

// Components
import StatusContent from '../StatusContent/StatusContent';
import Map from '../Map/Map';

// StyleSheet
import '../SearchBar/SearchBar.css';
import endpoints from '../../../config/endpoints';

import CircularProgress from '@material-ui/core/CircularProgress';

const initialState = {
    trackingNo: '',
    trackingNoError: '',
    loading: false,
}
class SearchBar extends Component {
    state = initialState;

    componentDidMount() {
        const getCheckParams = this.getParams();
        const trackingNo = getCheckParams;

        if (getCheckParams != null) {
            this.fetchData(getCheckParams)
            this.setState({ trackingNo });
        }
    }

    getParams = () => {
        const checkParams = new URLSearchParams(this.props.location.search).get(labels.TRACK_NO);

        return checkParams;
    }

    validate = (isError) => {
        const input = this.state.trackingNo;
        let trackingNoError = "";
        let isValid = true;

        if (!isError) {
            if (!input) {
                trackingNoError = labels.EMPTY_STATE;
                isValid = false;
            } 
            if (input.indexOf(' ') >= 0){
                trackingNoError = "Please enter a valid tracking number.";
                isValid = false;
            }
        } else {
            trackingNoError = "We didn't find any records.";
            isValid = false;
        }
        
        this.setState({ trackingNoError, loading: false })
        return isValid;
    }

    fetchData = (trackingNo) => {
        const searchUrl = `${process.env.REACT_APP_SERVER_URL}/${process.env.REACT_APP_CONTEXT_PATH}/${endpoints.TRACKING}/${trackingNo}`;

        axios.get(searchUrl)
        .then(res => {
            const getData = res.data;
            const docActivities = getData.documentActivities;
            const departmentDetails = getData.department;

            const statusCurr = getData.documentActivities
            const resultStatus = statusCurr[statusCurr.length - 1];

            const strStatus = resultStatus.documentStatus;
            const resStatus = strStatus.replace(labels.IN_TRANSIT, labels.BEING_DELIVERED);

            // for map display
            const locationStatus = resultStatus.location
            const locationArr = locationStatus.split(",")
            const longitude = parseFloat(locationArr[0]);
            const latitude = parseFloat(locationArr[1]);
            
            if (strStatus === labels.IN_TRANSIT) {
                // rider details
                const riderDetails = getData.driverDTO;
                const riderName = riderDetails.firstName + " " + riderDetails.lastName;
                const getDateTime = getData.documentActivities;
                const getLastDatime = getDateTime[getDateTime.length -1];
                const dateTime = getLastDatime.activityTimestamp;
                
                var renderMap = (
                    <Map 
                        lati={latitude} 
                        longi={longitude} 
                        resStatus={resStatus}
                        riderName={riderName}
                        date={dateTime}
                        time={dateTime}
                    />
                )
            } else {
                var renderStatus = (
                    <StatusContent
                        departmentName={departmentDetails.name}
                        departmentAddress={departmentDetails.address} 
                        docActivities={docActivities} />
                )
            } 

            this.setState({ 
                initialState, 
                renderStatus, 
                renderMap,
                loading: false 
            });
        })
        .catch((error) => {
            this.validate(error)
        })
    }

    handleChange = event => {
        this.setState({[event.target.name] : event.target.value});
    };

    handleSubmit = (event) => {
        event.preventDefault();
        const document = this.state.trackingNo;
        const isValid = this.validate();

        if (isValid) {
            this.setState({ loading: true }, () => {
                this.fetchData(document);
            });
        }
        
        this.props.history.push(`/track?${labels.TRACK_NO}=${document}`);
    }

    render() {
        const loading = this.state.loading;
        // const checkParams = this.getParams();

        return (
            <div id="searchbar__wrapper">
                <Container>
                    <Grid container direction="row">
                        <Grid item xs={12}>
                            <div className="title__body">
                                <Typography component="h1" variant="h4">{labels.TITLE}</Typography>
                            </div>
                        </Grid>

                        <Grid item xs={12}>
                            <div className="form__wrapper">
                                <form onSubmit={this.handleSubmit}>
                                    <Grid container  direction="row">
                                        <Grid item xs={12}>
                                            <Typography component="h1" variant="h5" className="field__label">{labels.SEARCH_TITLE}</Typography>
                                        </Grid>
                                        <div className="fields__container">
                                            <Grid container spacing={2} direction="row">
                                                <Grid item xs={12} md={8} className="container__field">
                                                    <TextField
                                                        fullWidth
                                                        type="text"
                                                        variant="outlined"
                                                        name="trackingNo"
                                                        label="Enter a valid tracking number"
                                                        value={this.state.trackingNo}
                                                        onChange={this.handleChange}
                                                        required
                                                        className="input__field--track"
                                                    />
                                                    <div className="error__content">
                                                        <Typography component="h1" variant="h4" className="text-danger">{this.state.trackingNoError}</Typography>
                                                    </div>
                                                </Grid>
                                                <Grid item xs={12} md={4} className="button__container">
                                                    <Button 
                                                        type="submit" 
                                                        fullWidth 
                                                        variant="contained"
                                                        color="primary"
                                                        size="large">
                                                            {labels.BTN_LABEL}
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </div>
                                    </Grid>
                                </form>
                            </div>
                        </Grid>
                        <Grid item xs={12}>
                            {loading ? 
                                <div style={{ margin: "0 auto", textAlign: "center" }}>
                                    <CircularProgress className="CircularProgress" />
                                </div> : 
                                <div>
                                    {this.state.renderStatus}
                                    {this.state.renderMap}
                                </div>
                            }
                            
                        </Grid>
                    </Grid>
                </Container>
            </div>
        )
    }
}

export default withRouter(SearchBar);






